<template>
  <div
    class="drop-zone"
    title="Click here to select a file"
    :class="{'drop-zone--hover': isHovering}"
    @dragover.prevent.stop="onDragOver"
    @dragleave.prevent.stop="onDragLeave"
    @drop="onDrop"
    @click="openFileBrowser"
  >
    <slot></slot>
    <input
      type="file"
      :accept="accept"
      multiple
      @change="onPick"
      ref="file"
    >
  </div>
</template>

<style lang="scss">
@import '../../styles/quasar.variables';

.drop-zone {
  border-radius: 5px;
  border: 2px dashed $grey-5;
  cursor: pointer;

  &--hover, &:hover {
    border-color: $primary;
  }

  input {
    display: none;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';

interface Data {
  isHovering: boolean
}

export default defineComponent({
  emits: ['drop'],
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    allowedExtensions: Array as () => string[],
  },
  data(): Data {
    return {
      isHovering: false,
    };
  },
  computed: {
    accept(): string|undefined {
      if (!this.allowedExtensions) return undefined;
      return this
        .allowedExtensions
        .map(extension => `.${extension}`)
        .join(',');
    },
  },
  methods: {
    openFileBrowser(): void {
      if (this.disable) return;
      (this.$refs.file as HTMLInputElement).value = '';
      (this.$refs.file as HTMLInputElement).click();
    },
    onPick(e: Event): void {
      e.stopPropagation();
      e.preventDefault();
      if (e.target === null) return;
      const { files } = (e.target as HTMLInputElement);
      if (files !== null && files.length) {
        this.$emit('drop', files);
      }
    },
    onDragOver() {
      this.isHovering = true;
    },
    onDragLeave() {
      this.isHovering = false;
    },
    onDrop(e: Event): void {
      e.stopPropagation();
      e.preventDefault();
      const event = (e as DragEvent);
      if (event.dataTransfer === null) return;
      const { files } = event.dataTransfer;
      if (files.length) {
        this.$emit('drop', files);
      }
    },
  },
});
</script>
